import React, { useEffect, useState } from "react";
import { Container, Spinner, Alert } from "react-bootstrap";
import {
  getGalleryFolderList,
  uploadGalleryImages,
  getGalleryImages,
  deleteGalleryImages,
} from "../../../api";
import "./manage-gallery.css";

const ManageGallery = () => {
  const [folders, setFolders] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState("");
  const [images, setImages] = useState([]);
  const [files, setFiles] = useState([]);

  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ type: "", message: "" });

  useEffect(() => {
    fetchFolders();
  }, []);

  const fetchFolders = async () => {
    try {
      const res = await getGalleryFolderList();
      setFolders(res.data || []);
    } catch (err) {
      setAlert({ type: "error", message: "Failed to load folders" });
    }
  };

  const fetchImages = async (folder) => {
    try {
      setLoading(true);
      const res = await getGalleryImages(folder);
      setImages(res.data || []);
    } catch (err) {
      setAlert({ type: "error", message: "Failed to load images" });
    } finally {
      setLoading(false);
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!selectedFolder || files.length === 0) {
      setAlert({ type: "error", message: "Select folder and images" });
      return;
    }

    try {
      setLoading(true);
      const res = await uploadGalleryImages(selectedFolder, files);

      if (res.data?.status === "success") {
        setAlert({ type: "success", message: "Images uploaded successfully" });
        setFiles([]);
        fetchImages(selectedFolder);
      } else {
        setAlert({ type: "error", message: "Upload failed" });
      }
    } catch (err) {
      setAlert({ type: "error", message: "Upload error occurred" });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (image) => {
    if (!window.confirm("Delete this image?")) return;

    try {
      await deleteGalleryImages(selectedFolder, [image]);
      fetchImages(selectedFolder);
    } catch (err) {
      setAlert({ type: "error", message: "Failed to delete image" });
    }
  };

  return (
    <section className="manage-gallery-page">
      <Container>
        <h2>Manage Gallery Images</h2>

        {/* Alert */}
        {alert.message && (
          <div className={`gallery-alert ${alert.type}`}>
            {alert.message}
            <span
              className="close-btn"
              onClick={() => setAlert({ message: "", type: "" })}
            >
              ×
            </span>
          </div>
        )}

        {/* Upload Section */}
        <div className="gallery-card">
          <form className="gallery-form" onSubmit={handleUpload}>
            <label>Select Folder</label>
            <select
              value={selectedFolder}
              onChange={(e) => {
                setSelectedFolder(e.target.value);
                fetchImages(e.target.value);
              }}
            >
              <option value="">-- Select Folder --</option>
              {folders.map((f, i) => (
                <option key={i} value={f.name}>
                  {f.name}
                </option>
              ))}
            </select>

            <label>Select Images</label>
            <input
              type="file"
              multiple
              accept="image/*"
              onChange={(e) => setFiles(Array.from(e.target.files))}
            />

            <button className="upload-btn" disabled={loading}>
              {loading ? "Uploading..." : "Upload Images"}
            </button>
          </form>
        </div>

        {/* Gallery Section */}
        <div className="gallery-card">
          <h2>Images</h2>

          {loading && (
            <div className="text-center py-4">
              <Spinner animation="border" />
            </div>
          )}

          {!loading && images.length === 0 && (
            <p className="empty-text">No images found</p>
          )}

          <div className="gallery-grid">
            {images.map((img, index) => (
              <div className="gallery-item" key={index}>
                <img src={img.url || img} alt="gallery" />
                <button
                  className="delete-btn"
                  onClick={() => handleDelete(img.name || img)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ManageGallery;
